import React, { useState } from "react"
import Box from "@mui/material/Box"
import { Typography } from "@mui/material"
import ButtonWithIcon from "../Button/Button"
import { ReactComponent as PlusSquareIcon } from "src/v2/assets/icons/plus-square-icon.svg"
import { ReactComponent as FileIcon } from "src/v2/assets/icons/file-icon.svg"
import { ReactComponent as DeleteIcon } from "src/v2/assets/icons/close-square-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"

import PropTypes from "prop-types"

const UploadComponent = ({
    fileInputRef,
    onFileSelect,
    onSendFile,
    compact = false,
    accept = ".csv, .pdf, .doc, .docx, .xlsx, .xls, .ptx, .ppt",
    buttonLabel = "ENVIAR ARQUIVO",
    helperText = "Ou arraste e solte os arquivos aqui",
}) => {
    const [selectedFile, setSelectedFile] = useState(null)
    const [isDragging, setIsDragging] = useState(false)

    const handleFileChange = (event) => {
        const file = event.target.files[0]

        if (!file) return

        setSelectedFile(file)

        if (onFileSelect) {
            onFileSelect(file)
        }
    }

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click()
        }
    }

    const handleDragEnter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(true)
    }

    const handleDragLeave = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(false)
    }

    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(false)

        const file = e.dataTransfer.files[0]

        if (file) {
            setSelectedFile(file)

            if (onFileSelect) {
                onFileSelect(file)
            }
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault()
    }

    const handleClickDeleteButton = () => {
        setSelectedFile(null)

        if (fileInputRef.current) {
            fileInputRef.current.value = ""
        }

        if (onFileSelect) {
            onFileSelect(null)
        }
    }

    if (selectedFile) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 2,
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <FileIcon />

                    <Typography
                        color="common.white"
                        variant="textBody"
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {selectedFile && selectedFile.name}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexShrink: 0,
                    }}
                >
                    {onSendFile && (
                        <ButtonWithIcon
                            size="sm"
                            icon={<CheckIcon />}
                            onClick={() => onSendFile(selectedFile)}
                        >
                            ENVIAR
                        </ButtonWithIcon>
                    )}

                    <ButtonWithIcon
                        icon={<DeleteIcon />}
                        onClick={handleClickDeleteButton}
                    >
                        EXCLUIR
                    </ButtonWithIcon>
                </Box>
            </Box>
        )
    }

    return (
        <Box
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                border: isDragging
                    ? "2px dashed #E3A404"
                    : "1px dashed #FFFFFF",
                borderRadius: compact ? "12px" : 0,
                paddingY: compact ? "20px" : "40px",
                paddingX: compact ? "32px" : 0,
            }}
        >
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept={accept}
            />

            <Box
                sx={{
                    display: "flex",
                    width: "fit-content",
                    whiteSpace: "nowrap",
                    flexDirection: compact ? "row" : "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: compact ? 3 : 2,
                }}
            >
                <ButtonWithIcon
                    size={compact ? "md" : "lg"}
                    icon={<PlusSquareIcon />}
                    onClick={handleButtonClick}
                >
                    {buttonLabel}
                </ButtonWithIcon>

                <Typography variant="body2" color="common.white">
                    {helperText}
                </Typography>
            </Box>
        </Box>
    )
}

UploadComponent.propTypes = {
    fileInputRef: PropTypes.object.isRequired,
    onFileSelect: PropTypes.func,
    onSendFile: PropTypes.func,
    compact: PropTypes.bool,
    accept: PropTypes.string,
    buttonLabel: PropTypes.string,
    helperText: PropTypes.string,
}

export default UploadComponent
